import {Alert, AlertTitle, Button, Slide, Snackbar, SxProps} from '@mui/material';
import {
  CancelOutlined,
  CheckCircleOutlineOutlined,
  InfoOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';
import {useSnackBar} from '../../../contexts/snack-bar/context';

export const AlertSnackbar = () => {
  const snackBarContext = useSnackBar();

  const snackBarSx: SxProps = {
    zIndex: 9999,
    display: 'flex',
    alignItems: 'flex-end',
    left: '16px!important',
    right: '16px!important',
    width: 'calc(100% - (16px * 2px))',
    alignContent: 'flex-end',
  };

  return (
    <Snackbar
      TransitionComponent={Slide}
      anchorOrigin={{vertical: 'top', horizontal: 'left'}}
      open={snackBarContext.state.officeToastNotification.open}
      autoHideDuration={snackBarContext.state.officeToastNotification.autoHideDuration}
      onClose={snackBarContext.resetOfficeToastNotification}
      sx={snackBarSx}
    >
      <Alert
        key={`${snackBarContext.state.officeToastNotification.message}_${snackBarContext.state.officeToastNotification.severity}`}
        variant="outlined"
        onClose={snackBarContext.resetOfficeToastNotification}
        severity={snackBarContext.state.officeToastNotification.severity}
        iconMapping={{
          info: <InfoOutlined />,
          success: <CheckCircleOutlineOutlined />,
          error: <CancelOutlined />,
          warning: <WarningAmberOutlined />,
        }}
        action={
          snackBarContext.state.officeToastNotification.buttonLabel && (
            <Button color="inherit" size="small">
              {snackBarContext.state.officeToastNotification.buttonLabel}
            </Button>
          )
        }
      >
        {snackBarContext.state.officeToastNotification.title && (
          <AlertTitle>{snackBarContext.state.officeToastNotification.title}</AlertTitle>
        )}
        {snackBarContext.state.officeToastNotification.message}
      </Alert>
    </Snackbar>
  );
};
